import { render, staticRenderFns } from "./AccidentCreate.vue?vue&type=template&id=790ba3b8&"
import script from "./AccidentCreate.vue?vue&type=script&lang=js&"
export * from "./AccidentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports